import config from "../config"
import ProductModel from "shop/ProductModel"
import SessionModel from "shop/SessionModel"
import DownloadStore from "shop/DownloadStore"

import OrderlistStore from "sdk/store/OrderlistStore"
import AddressStore from "sdk/store/AddressStore"

// new land (direct importing creates compile time errors)
import categoryStore from "stores/categoryStore"
import languageStore from "stores/languageStore"

import Api from "sdk/Api.js"

const shop = new Api( config )

// Edit below this line

shop.ProductModel     = ProductModel
shop.SessionModel     = SessionModel
shop.name             = "SCANTEX"
shop.store            = {}
shop.store.categories = categoryStore
shop.store.language   = languageStore
shop.store.downloads  = new DownloadStore( shop )
shop.store.addresses  = new AddressStore( shop )
shop.store.orderlist  = new OrderlistStore( shop )


window.shop = shop // DEBUG
export default shop



// WEBPACK FOOTER //
// ./src/theme/base/shop/shop.js